import * as actionTypes from '../actions/actionTypes';
import { store } from 'index.js';

const initState = {
  loading: false,
  list: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LIST_START:
      return { ...state, loading: true };
    case actionTypes.FETCH_LIST_END:
      const { list } = action.data;
      return { ...state, loading: false, list };
    case actionTypes.DL_LIST_START:
      return { ...state, loading: true };
    case actionTypes.DL_LIST_END:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const parseUserData = list => {
  if (!list) return list;
  const {
    user: { users },
  } = store.getState();
  if (!users) return list;
  const newList = { ...list };
  console.log(list);
  newList['user'] = users.find(e => e.id === list['user_id']);
  return newList;
};



// WEBPACK FOOTER //
// ./src/store/reducers/list.js